type ConsentCheckboxProps = {
  name: string
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  required?: boolean
  disabled?: boolean
  description?: string
}

export function ConsentCheckbox({ name, label, checked, onChange, required, disabled, description }: ConsentCheckboxProps) {
  return (
    <div className="flex items-start gap-3">
      {/* Wrap the checkbox in a one-line-tall box so it stays vertically centered on the
          first line of the (possibly multi-line) label, independent of its line-height. */}
      <span className="flex h-6 shrink-0 items-center">
        <input
          id={name}
          checked={checked}
          className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50"
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          type="checkbox"
        />
      </span>
      <div className="flex-1">
        <label className={disabled ? 'cursor-not-allowed text-sm leading-6 text-gray-400' : 'cursor-pointer text-sm leading-6 text-gray-900'} htmlFor={name}>
          {label}
          {required && <span className="ml-1 text-red-600">*</span>}
        </label>
        {description && <span className="mt-1 block text-xs leading-5 text-gray-500">{description}</span>}
      </div>
    </div>
  )
}
